import $ from 'jquery'

$(document).on('turbo:load', () => {
  const isFileEmpty = (container) => {
    const $container = $(container)
    return (
      ($container.find('input').val() === '' || undefined) &&
      $container.data('attachment-present') === undefined
    )
  }
  // 「先頭から順に表示して最初の空欄で打ち切る」方式だと、途中の欄を解除したときに後続の添付済み欄が非表示のまま送信されてしまうため、空欄フラグで判定する
  const displayOnlyLastEmptyFileInput = (messageContainer) => {
    let emptyShown = false
    $(messageContainer).find('.js-attachment').each((_, elm) => {
      const empty = isFileEmpty(elm)
      $(elm).toggle(!empty || !emptyShown)
      if (empty) emptyShown = true
    })
  }
  $('.js-toggle-message-form-link').on('click', (event) => {
    event.preventDefault()
    displayOnlyLastEmptyFileInput($(event.target).closest('.js-message-container'))
    const $target = $(event.target)
    const messageId = $target.data('message-id')
    const $body = $(`#message-detail-${messageId} .message__body`)
    const $form = $(`#message-detail-${messageId} .message__form-container`)
    if ($body.is(':visible')) {
      $target.text('キャンセル')
      $body.hide()
      $form.show()
    } else {
      $target.text('編集')
      $body.show()
      $form.hide()
    }
  })
  $('.js-attachment input').on('change', (event) => {
    displayOnlyLastEmptyFileInput($(event.target).closest('.js-message-container'))
  })
  displayOnlyLastEmptyFileInput($('.js-new-message'))
})
